import { render, staticRenderFns } from "./sprv.vue?vue&type=template&id=c84da264&scoped=true&"
import script from "./sprv.vue?vue&type=script&lang=js&"
export * from "./sprv.vue?vue&type=script&lang=js&"
import style0 from "./sprv.vue?vue&type=style&index=0&id=c84da264&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c84da264",
  null
  
)

export default component.exports